export default price => {
  // 1000 -> 1.000

  if (price < 1000) {
    return price
  }

  return price?.toLocaleString('es-AR')
}
